<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-21 19:29:16
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-02-16 11:05:32
-->
<template>
  <div :class="{ 'has-logo': appConfig.showLogo }">
    <el-scrollbar :class="'theme-dark'" wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="'#fff'"
        :text-color="'#303133'"
        :unique-opened="true"
        :active-text-color="'#017EFA'"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in menus" :key="route.router" :item="route" :base-path="route.router" :hiddenMenuName="isCollapse" />
      </el-menu>
    </el-scrollbar>
    <div :class="['sider-footer-btn', isCollapse ? 'is-collapse' : '']" @click="setSidebarHide()">
      <em :class="['iconfont', !isCollapse ? 'icon-shouqicaidan' : 'icon-zhankaicaidan']"></em>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'pinia'
  // import loginStore from '@main/modules/login/pinia/pinia.js'
  // import appSettings from '@main/common/pinia/setting'
  import { pinias } from '@main/common/pinia'
  import { cloneDeep } from '@package/utils'

  import SidebarItem from './barItem.vue'

  const { settings, login, cachedView } = pinias
  export default {
    components: {
      SidebarItem
    },
    data() {
      return {
        menus: []
      }
    },
    computed: {
      ...mapState(settings, ['appConfig', 'sidebar']),
      ...mapState(login, ['permissionsMenu']),
      activeMenu() {
        const route = this.$route
        const { meta, path } = route
        this.addView(route)
        // if set path, the sidebar will highlight the path you set
        // if (meta.parentTitle && meta.parentTitle.length > 1) {
        //   return meta.parentTitle[1].path
        // }
        return path
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    },
    watch: {
      permissionsMenu: {
        handler(val) {
          if (JSON.stringify(val) !== this.menus) {
            this.menus = cloneDeep(val)
          }
        },
        immediate: true,
        deep: true
      },
      $route() {
        const { name } = this.$route
        if (name) {
          this.addView(this.$route)
        }
      }
    },
    created() {},
    methods: {
      ...mapActions(settings, ['setSidebarHide']),
      ...mapActions(cachedView, ['addView'])
    }
  }
</script>
<style lang="scss" scoped>
  .sider-footer-btn {
    position: absolute;
    bottom: 10px;
    display: flex;
    justify-content: center;
    width: 85%;
    margin: 10px 16px;
    padding: 4px 0;
    cursor: pointer;
    border-radius: 10px;
    background: #dfe7f7;

    &.is-collapse {
      width: 70%;
      margin: 10px 12px;
    }

    .iconfont {
      font-size: 26px;
    }
  }
</style>
